import { Component, HostListener, OnInit, ViewChild } from '@angular/core'
import { MatPaginator, PageEvent } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { MatTable, MatTableDataSource } from '@angular/material/table'
import { ActivatedRoute, Router } from '@angular/router'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { ProductsService, productsTableColumns } from '../../products/products.service'
import { CouponsService } from '../coupons.service'
import { AfterViewInit } from '@angular/core'
import { SettingsService } from '../../settings/settings.service'
import { NgForm } from '@angular/forms'
import { CategoriesService, categoriesTableColumns } from '../../categories/categories.service'
import { VendorService } from 'src/app/multivendor/vendor.service'

export interface Coupon {
  id?: string
  name: string
  expirationDate: string
  amount: number
  discountType: 'percentage' | 'specific_amount'
  discountCriteria: 'fixed_products_discount' | 'fixed_categories_discount' | 'whole_cart_discount'

  usageTime: number
  usageTimes: number
  uses: number
  min: number
  max: number
  selectedProducts?: productsTableColumns[]
  selectedCategories?: categoriesTableColumns[]
  active: boolean
}
export interface User {
  id?: string
  name: string
  email: string
}
@Component({
  selector: 'app-add-coupon',
  templateUrl: './add-coupon.component.html',
  styleUrls: ['./add-coupon.component.scss']
})
export class AddCouponComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator
  @ViewChild(MatSort, { static: true }) matSort!: MatSort
  @ViewChild('usersPaginator') usersPaginator!: MatPaginator
  @ViewChild('productPaginator') productPaginator!: MatPaginator
  @ViewChild(MatTable) pTable!: MatTable<productsTableColumns>
  @ViewChild(MatTable) cTable!: MatTable<categoriesTableColumns>
  @ViewChild('f', { static: true }) couponForm!: NgForm

  categories: any = {}
  ELEMENT_DATAP: productsTableColumns[] = []
  ELEMENT_DATAC: categoriesTableColumns[] = []
  filteredProducts: productsTableColumns[] = []
  displayedProducts: productsTableColumns[] = []
  pageSize = 5
  pageIndex = 0
  displayedColumns: string[] = ['selectImageName']
  public selectedCategoriesDataSource = new MatTableDataSource<categoriesTableColumns>() // Assuming Category is your model interface

  public selectedProductsDataSource: MatTableDataSource<productsTableColumns> = new MatTableDataSource()

  public selectedProductsColumns: string[] = ['select', 'image', 'name', 'stock']
  public usersColumns: string[] = ['id', 'userName', 'userUses', 'email']
  filteredUsersList = new MatTableDataSource<any>()

  public productsDataSource: MatTableDataSource<productsTableColumns> = new MatTableDataSource()
  public categoriesDataSource: MatTableDataSource<categoriesTableColumns> = new MatTableDataSource()
  public productsColumns: string[] = []

  public dataSource: any = []
  products_dates: any = []
  public elements: any[] = []
  products_data_counts: any = []

  discountType = ['percentage', 'specific_amount']
  discountTypeMap: { [key: string]: string } = {
    percentage: 'Percentage',
    specific_amount: 'Specific Amount'
  }

  dropdownOpen: { [key: string]: boolean } = {}
  dropdownTouched: { [key: string]: boolean } = {}

  get criteriaOptions(): { value: string; label: string }[] {
    const opts: { value: string; label: string }[] = []
    if (!this.vendor.isMultiVendor) {
      opts.push(
        { value: 'fixed_products_discount', label: 'Fixed Products Discount' },
        { value: 'fixed_categories_discount', label: 'Fixed Category Discount' }
      )
    }
    opts.push({ value: 'whole_cart_discount', label: 'Whole Cart Discount' })
    return opts
  }

  get typeOptions(): { value: string; label: string }[] {
    return Object.entries(this.discountTypeMap).map(([key, val]) => ({ value: key, label: val }))
  }

  getOptionLabel(options: { value: string; label: string }[], value: any): string {
    if (!value) return ''
    return options.find(o => o.value === value)?.label ?? String(value)
  }

  toggleDropdown(key: string, event: Event) {
    event.stopPropagation()
    const wasOpen = !!this.dropdownOpen[key]
    this.closeAllDropdowns()
    this.dropdownOpen[key] = !wasOpen
  }

  selectCouponOption(key: string, value: string, event: Event) {
    event.stopPropagation()
    if (key === 'selectedCriteria') this.selectedCriteria = value
    else if (key === 'selectedType') this.selectedType = value
    this.dropdownOpen[key] = false
    this.dropdownTouched[key] = true
  }

  @HostListener('document:click')
  closeAllDropdowns() {
    this.dropdownOpen = {}
  }
  public invalidationMessage: string = ''
  selectedCriteria: string = ''
  selectedType: string = ''
  discountDefaultInput: number = 0
  discountPercentage: number = 0
  discountAmount: number = 0
  couponName: string = ''
  dateInput: string = ''
  couponUid: string = ''
  couponId: string = ''
  usageTime: number = 0
  usageTimes: number = 0
  uses: number = 0
  min: number = 0
  active: boolean = true
  searchText: string = ''
  usersPageIndex = 0
  usersPageSize = 5
  max: number = 0
  couponsArray: Coupon[] = [] // Define it as a class property
  public editPage: boolean = false
  selectedCategories: any[] = []
  selectedProducts: any[] = []
  project_id = this.builderService.selectedProject

  constructor(
    private couponsService: CouponsService,
    public productsService: ProductsService,
    private categoriesService: CategoriesService,
    public builderService: BuilderService,
    public vendor: VendorService,
    private router: Router,
    private route: ActivatedRoute,
    public settingsService: SettingsService
  ) {}
  ngAfterViewInit() {
    this.filteredUsersList.paginator = this.usersPaginator
    this.filteredUsersList.sort = this.matSort
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.couponId = params.get('id') || ''
      if (this.couponId) {
        this.loadCoupon(this.couponId)
        this.loadCouponUsers(this.couponId)
      }
    })

    this.loadCoupons()
    this.selectedCategoriesDataSource.data = this.selectedCategories

    this.getAllProducts() // Fetch products
    this.getCategories()
    setTimeout(() => {
      this.updateSelectedProductsTable()
      this.updateSelectedCategories()
    }, 500)
  }


  updateSelectedProductsTable() {
    this.selectedProductsDataSource = new MatTableDataSource(this.selectedProducts)
  }
  updateSelectedCategories() {
    this.selectedCategoriesDataSource.data = this.selectedCategories
  }


  /**
  loadCoupon is for the edit button so when i can get the coupon id to use it in the edit page to edit an existed coupon
  @param id which is string
  @returns null
    */
  loadCoupon(id: string) {
    this.editPage = true
    this.couponsService.getCoupon(id).subscribe((coupon) => {
      this.couponUid = id
      this.couponName = coupon.name
      this.dateInput = coupon.expirationDate
      this.discountPercentage = coupon.discountType === 'percentage' ? coupon.amount : 0
      this.discountAmount = coupon.discountType === 'specific_amount' ? coupon.amount : 0
      this.selectedType = coupon.discountType
      this.selectedCriteria = coupon.discountCriteria
      this.usageTime = coupon.usageTime
      this.usageTimes = coupon.usageTimes
      if (coupon.uses) {
        this.uses = coupon.uses
      }
      this.min = coupon.min
      this.max = coupon.max
      this.selectedProducts = coupon.selectedProducts || []
      this.selectedCategories = coupon.selectedCategories || []
      this.active = coupon.active
    })
  }
  loadCouponUsers(couponId: string) {
    this.couponsService.getCouponUsers(couponId).subscribe(
      (users: any[]) => {
        this.filteredUsersList.data = users
      },
      (error) => {
        console.error('Error fetching coupon users:', error)
      }
    )
  }

  loadCoupons() {
    this.couponsService.getCoupons().subscribe((coupons: any) => {
      this.couponsArray = Object.keys(coupons).map((key) => ({
        id: key,
        ...coupons[key]
      }))
    })
  }
  /**
   this getAllProducts i get with it the products list so i can put it in the table and i specified a columns which is
  ['image', 'name', 'stock', 'price', 'date'] so i can put these in the table
  @input null
  @returns null
  */
  getAllProducts() {
    this.productsService.fetchPage(0, 1000).subscribe((response_products: any) => {
      this.builderService.showUpdateProgress = true
      this.productsColumns = ['image', 'name', 'stock', 'price', 'date']
      this.ELEMENT_DATAP = response_products
      this.filteredProducts = [...this.ELEMENT_DATAP]
      this.resetPaging()
      this.updateDisplayedProducts()
      this.builderService.showUpdateProgress = false
    })
  }
  getCategories() {
    this.categoriesService.loadCategories().subscribe((categories: any) => {
      if (categories) {
        this.categories = categories
        this.ELEMENT_DATAC = this.categories
        this.categoriesDataSource = new MatTableDataSource(this.ELEMENT_DATAC)
        this.dataSource = new MatTableDataSource<categoriesTableColumns>(this.ELEMENT_DATAC)
        this.categoriesDataSource.paginator = this.paginator
        this.categoriesDataSource.sort = this.matSort
      }
    })
  }
  /**
   * this method checks if the selected discount type is'Percentage' and if it is returns boolean(true) if its not returns
   * boolean(false) so when if i choose the discount type 'Percentage' the 'Percentage' input appears.
   @params null
    @returns boolean
  */
  isPercentage(): boolean {
    return this.selectedType === 'percentage'
  }

  /**
   * this method checks if the selected discount type is 'Specific Amount' and if it is returns boolean(true) if its not returns
   * boolean(false) so when if i choose the discount type : 'Specific Amount' the 'Specific Amount' input appears.
   @params null
    @returns boolean
  */
  isAmount(): boolean {
    return this.selectedType === 'specific_amount'
  }
  /**
   * this method checks if the selected discount criteria is 'Fixed Product Discount' and if it is returns boolean(true) if its not returns
   * boolean(false)
   @params null
    @returns boolean
  */
  showProducts(): boolean {
    return this.selectedCriteria === 'fixed_products_discount'
  }
  /**
   * this method checks if the selected discount criteria is 'Fixed Category Discount' and if it is returns boolean(true) if its not returns
   * boolean(false)
   @params null
    @returns boolean [class.hidden]="!showCategories()"
  */
  showCategories(): boolean {
    return this.selectedCriteria === 'fixed_categories_discount'
  }

  /**
   * this method save the coupon in the database so when i fill all the input fields and click (Publish) the coupon now is save in the database
   * with these properties ['name','expirationDate','amount','discountType','discountCriteria','usageTime','usageTimes','min','max']
   * and checks if there is a coupon id (when i press on edit so it get me to the route /coupons/add-coupon/:id) then i can edit it with the existed properties
   * @params formValues which got any type
   * @returns null
   */
  save(formValues: any) {
    if (formValues.min == null || formValues.max == null) {
      formValues.min = 0
      formValues.max = 0
    }
    let expirationDate = ''

    if (formValues.dateInput) {
      const date = new Date(formValues.dateInput)

      if (!isNaN(date.getTime())) {
        // Get the date parts manually to avoid time zone issues
        const year = date.getFullYear()
        const month = (date.getMonth() + 1).toString().padStart(2, '0') // Months are 0-indexed
        const day = date.getDate().toString().padStart(2, '0')

        expirationDate = `${year}-${month}-${day}`
      }
    }
    const couponName = formValues.couponName
    this.invalidationMessage = ''
    const nameExists = this.couponsArray.some((coupon) => coupon.name.toUpperCase() === couponName.toUpperCase() && coupon.id !== this.couponId)

    if (nameExists) {
      this.invalidationMessage = 'Coupon name already exists.'
      return
    }

    const coupon: Coupon = {
      name: couponName,
      expirationDate: expirationDate,
      amount: this.isPercentage() ? this.discountPercentage : this.discountAmount,
      discountType: this.selectedType as 'percentage' | 'specific_amount',
      discountCriteria: this.selectedCriteria as 'fixed_products_discount' | 'fixed_categories_discount' | 'whole_cart_discount',

      usageTime: formValues.usageTime,
      usageTimes: formValues.usageTimes,
      min: formValues.min,
      max: formValues.max,
      selectedProducts: this.selectedProducts, // Include selected products
      selectedCategories: this.selectedCategories,
      uses: this.uses,
      active: this.active
    }

    if (this.couponId) {
      this.couponsService.updateCoupon(this.couponId, coupon).subscribe(
        (response) => {
          this.router.navigate(['/coupons'])
        },
        (error) => {
          console.error('Error updating coupon:', error)
        }
      )
    } else {
      this.couponsService.submitCoupon(coupon).subscribe(
        () => {
          this.router.navigate(['/coupons'])
        },
        (error) => {
          console.error('Error saving coupon:', error)
        }
      )
    }
    if (this.vendor.isMultiVendor) this.vendor.syncSuperVendorSettingsToVendors()
  }

  /**
   * this method i use in the (Publish) submit button so when i click on submit it checks if all the inputs are filled and if they are
   * it publish the coupon and if they arenot it doesnt publish the coupon and get the validation errors in the inputs
   * @param form which is any
   * @returns null
   */
  onSubmit(formValue: any) {
    this.dropdownTouched['selectedCriteria'] = true
    this.dropdownTouched['selectedType'] = true
    if (this.couponForm.invalid || !this.selectedCriteria || !this.selectedType) {
      this.couponForm.form.markAllAsTouched()
      return
    }

    // If the form is valid, proceed with saving the coupon
    this.save(formValue)
  }

  onProductSelect(product: any, event: any): void {
    const productWithType = { ...product, type: 'product' }
    if (event.checked) {
      if (!this.selectedProducts.some((p) => (p.Id && p.Id === productWithType.Id) || p.productName === productWithType.productName)) {
        this.selectedProducts.push(productWithType)
      } else {
        // Replace stub entry (loaded from DB with only Id) with full product data
        const stubIndex = this.selectedProducts.findIndex((p) => p.Id === productWithType.Id && !p.productName)
        if (stubIndex > -1) this.selectedProducts.splice(stubIndex, 1, productWithType)
      }
    } else {
      const index = this.selectedProducts.findIndex((p) =>
        (p.Id && p.Id === productWithType.Id) ||
        (p.productName === productWithType.productName && p.type === 'product')
      )
      if (index > -1) {
        this.selectedProducts.splice(index, 1)
      }
    }
    this.updateSelectedProductsTable()
  }

  onCategorySelect(category: any, event: any): void {
    const isChecked = event.checked
    const index = this.categories.findIndex((c: any) => c.categoryName === category.categoryName)
    if (index > -1) {
      this.categories[index].checked = isChecked
    }
    const categoryWithType = { ...category, type: 'category' }

    if (isChecked) {
      if (!this.selectedCategories.some((c) => (c.categoryId && c.categoryId === categoryWithType.categoryId) || c.categoryName === categoryWithType.categoryName)) {
        this.selectedCategories.push(categoryWithType)
      } else {
        // Replace stub entry (loaded from DB with only categoryId) with full category data
        const stubIndex = this.selectedCategories.findIndex((c) => c.categoryId === categoryWithType.categoryId && !c.categoryName)
        if (stubIndex > -1) this.selectedCategories.splice(stubIndex, 1, categoryWithType)
      }
    } else {
      const catIndex = this.selectedCategories.findIndex((c) =>
        (c.categoryId && c.categoryId === categoryWithType.categoryId) ||
        (c.categoryName === categoryWithType.categoryName && c.type === 'category')
      )
      if (catIndex > -1) {
        this.selectedCategories.splice(catIndex, 1)
      }
    }
    this.updateSelectedCategories()
  }

  isChecked(item: any, type: 'product' | 'category'): boolean {
    if (type === 'product') {
      return this.selectedProducts.some((p) =>
        (p.Id && p.Id === item.Id) ||
        (p.productName === item.productName && p.type === 'product')
      )
    } else if (type === 'category') {
      return this.selectedCategories.some((c) =>
        (c.categoryId && c.categoryId === item.categoryId) ||
        (c.categoryName === item.categoryName && c.type === 'category')
      )
    }

    return false
  }
  filterProducts(query: string) {
    if (query) {
      this.filteredProducts = this.ELEMENT_DATAP.filter((product) => product.productName.toLowerCase().includes(query.toLowerCase()))
    } else {
      this.filteredProducts = [...this.ELEMENT_DATAP]
    }
    this.resetPaging()
    this.updateDisplayedProducts()
  }

  /**
   * Resets the product pagination to the first page.
   */
  resetPaging() {
    this.pageIndex = 0
    if (this.paginator) {
      this.paginator.pageIndex = 0
    }
  }

  /**
   * Updates the displayed products based on the current page.
   */
  updateDisplayedProducts() {
    const startIndex = this.pageIndex * this.pageSize
    const endIndex = startIndex + this.pageSize
    this.displayedProducts = this.filteredProducts.slice(startIndex, endIndex)
    this.productsDataSource.data = this.displayedProducts
  }

  /**
   * Handles page change events from MatPaginator for products.
   */
  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize
    this.pageIndex = event.pageIndex
    this.updateDisplayedProducts()
  }

  filterCategories(queryC: string) {
    if (queryC) {
      const filteredCategories = this.ELEMENT_DATAC.filter((category) => category.categoryName.toLowerCase().includes(queryC.toLowerCase()))
      this.categoriesDataSource.data = filteredCategories
    } else {
      this.categoriesDataSource.data = this.ELEMENT_DATAC
    }
  }
  getStock(product: any): number {
    return Number(product.productStock) || 0
  }

  applyFilter(): void {
    const filterValue = this.searchText ? this.searchText.trim().toLowerCase() : ''
    this.filteredUsersList.filter = filterValue
    this.usersPageIndex = 0
  }

  getPagedUsers(): any[] {
    const start = this.usersPageIndex * this.usersPageSize
    return this.filteredUsersList.filteredData.slice(start, start + this.usersPageSize)
  }

  getTotalUserPages(): number {
    return Math.ceil(this.filteredUsersList.filteredData.length / this.usersPageSize) || 1
  }
}
